<template>
  <div>
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-primary">
        <div class="card-text">
          <h4 class="title">
            Notes
          </h4>
        </div>
      </md-card-header>
      <md-card-content>
        <div
          class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
        >
          <time-line plain type="simple">
            <time-line-item
              v-for="noteItem in statInspItem.notes"
              :key="noteItem.id"
              :value="noteItem.id"
              inverted
              :badge-type="getNoteColouring(noteItem.statusId, noteItem.source)"
              :badge-icon="noteIcon(noteItem.noteTypeId)"
            >
              <p slot="content">
                {{ writeNote(noteItem.note, noteItem.source) }}
              </p>

              <h6 slot="footer">
                <i class="ti-time text-gray">
                  {{ noteItem.createdDate | moment("MMMM Do YYYY HH:mm") }}
                  - {{ noteItem.createdBy }}</i
                >
              </h6>
            </time-line-item>
          </time-line>
        </div>
      </md-card-content>
    </md-card>

    <StatInspItemNoteForm
      :showModal="showNoteModal"
      @closeModal="closeModal"
    ></StatInspItemNoteForm>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import StatInspItemNoteForm from "./StatInspItemNoteForm";
import { TimeLine, TimeLineItem } from "@/components";
export default {
  components: {
    StatInspItemNoteForm,
    TimeLine,
    TimeLineItem
  },
  data() {
    return {
      showNoteModal: false
    };
  },
  computed: {
    ...mapGetters({
      statInsp: "stat-insp/statInsp",
      statInspItem: "stat-insp/statInspItem",
      statInspItemStatus: "stat-insp/statInspItemStatus",
      quoteStatus: "quote/getQuoteStatus",
      noteIcon: "noteIcons"
    })
  },
  methods: {
    canAddNote() {
      return (
        !this.statInsp.isPartial && this.statInspItem.statInspItemStatusId != 3
      );
    },
    closeModal(refresh) {
      this.showNoteModal = false;
      if (refresh) this.$emit("refresh");
    },
    getNoteColouring(statusId, source) {
      if (source === "StatInspNote")
        return this.statInspItemStatus(statusId).colour;
      else return "quote";
    },
    writeNote(note, source) {
      if (source !== "StatInspNote") return "QUOTE: " + note;
      else return note;
    }
  }
};
</script>

<style></style>
